module.exports = __webpack_public_path__ + "img/product_top.065eff89.jpg";